export default __webpack_public_path__ + "static/media/complete-white.94cbc8ae.svg";